import { render, staticRenderFns } from "./catalog-desktop.vue?vue&type=template&id=661bb772&"
import script from "./catalog-desktop.vue?vue&type=script&lang=js&"
export * from "./catalog-desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports